<template>
    <div class="fluid">
        <h1 class="app-title">Cadastro de Regras de Pagamento</h1>
        <b-card>
            <b-row class="d-flex justify-content-between">
                <b-col>
                    <CompBotaoExibirOcultarColuna
                            :fields="fields"
                            :showColunms="showColunms"
                            @toggleColuna="toggleColuna"/>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                                   class="mb-3 col-2" style="float:right"></b-form-select>
                    <b-button class="ml-2" variant="secondary" @click="limparFiltros"
                              style="float: right; margin-right: 10px; height: 32px; padding: 0 0.75rem;">
                        <i class="fas fa-broom"></i> Limpar Filtros
                    </b-button>
                </b-col>
            </b-row>
            <TabelaRegrasPagamento
                    :resultado="items"
                    :fields="fields"
                    :configTable="configTable"
                    :selecteds="selecteds"
                    :filtro="filtros"
                    @openFilterPopup="openFilterPopup"
                    @consultar="consultar"/>
            <b-row class="d-flex justify-content-between" style="margin-top: 10px;">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <div class="registros-encontrados">
                        <span>Regras Encontradas</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{configTable.perPage != 'Todos' ? configTable.rows : items.length}}</span>
                    </div>

                    <div class="registros-encontrados" style="margin-left: 15px">
                        <span>Regras Selecionadas</span>
                    </div>
                    <div class="registros-encontrados-valor">
                        <span>{{selecteds.length}}</span>
                    </div>
                </b-col>
            </b-row>
            <hr>
            <b-row>
                <b-col md="3"></b-col>
                <b-col md="6">
                    <div class="d-flex justify-content-between align-items-center">
                        <div style="margin: auto">
                            <b-button class="ml-2" variant="primary" @click="incluir">
                                <i class="fa fa-plus"></i> Incluir
                            </b-button>
                            <b-button class="ml-2" variant="secondary" @click="alterar" :disabled="selecteds.length !== 1">
                                <i class="fas fa-edit"></i> Editar
                            </b-button>
                            <b-button class="ml-2" variant="warning" @click="exibir" style="color: #FFF"
                                      :disabled="selecteds.length !== 1">
                                <i class="fas fa-eye"></i> Exibir
                            </b-button>
                        </div>
                    </div>
                </b-col>
                <b-col md="3"></b-col>
            </b-row>
        </b-card>
        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    import axios from 'axios'
    import TabelaRegrasPagamento from "./TabelaRegrasPagamento";
    import CompBotaoExibirOcultarColuna from "../shared/components/CompBotaoExibirOcultarColuna";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import formatarMixins from '../../mixins/formatarMixins';

    export default {
        components: {CompFiltroGrid, CompBotaoExibirOcultarColuna, TabelaRegrasPagamento, Multiselect},
        mixins: [ formatarMixins ],
        data() {
            return {
                urlApi: null,
                token: null,
                value: null,
                options: [
                    {name: 'ICMS', code: 'av'},
                    {name: 'ITCMD', code: 'pa'}
                ],
                indice: null,
                fields: [
                    {
                        key: "selecionar",
                    }
                ],
                items: [],
                configTable: {
                    perPage: 10,
                    lastPage: null,
                    sortField: 'pagamento.descricao',
                    sortOrder: 'asc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                },
                showColunms: [],
                selecteds: [],
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    campoTexto: null,
                    campoData: null,
                    campoRadio: null,
                    listaValores: []
                },
                filtros: {
                    nome: null,
                    filtrarNome: null,
                    vigenciaDe: null,
                    filtrarVigenciaDe: null,
                    vigenciaAte: null,
                    filtrarVigenciaAte: null,
                    receita: null,
                    filtrarReceita: null,
                    indice: null,
                    filtrarIndice: null,
                    valorMinimo: null,
                    filtrarValorMinimo: null,
                    percentual: null,
                    filtrarPercentual: null,
                    usuario: null,
                    filtrarUsuario: null,
                    dataInclusao: null,
                    filtrarDataInclusao: null,
                    dataUltimaAtualizacao: null,
                    filtrarDataUltimaAtualizacao: null,
                    situacao: null,
                    deliberacaoConselhoSid: null
                }
            }
        },
        methods: {
            async consultar() {
                let perPageStr = `&perPage=${this.configTable.perPage}`;
                if (this.configTable.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTable.currentPage = 1;
                    this.configTable.rows = 0;
                }

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/regrasPagamento/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.items = response.data.resultado;
                    if (this.configTable.perPage !== 'Todos') {
                        this.configTable.rows = response.data.rows;
                        this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
                    } else {
                        this.configTable.lastPage = 1;
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            prevPage() {
                this.configTable.currentPage = this.configTable.currentPage - 1;
                this.consultar();
            },

            nextPage() {
                this.configTable.currentPage = this.configTable.currentPage + 1;
                this.consultar();
            },

            async obterColunasUsuario() {
                const funcionalidade = 'regrasPagamento';

                this.configTable.load = true;
                axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    response.data.forEach((field, i) => {
                        if (field.ativo) {
                            this.showColunms.push(i + 1)
                        }
                        this.fields.push({
                            key: `${i + 1}`,
                            label: `${field.descricao}`,
                            thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                            codColunaFuncionalidade: field.codColunaFuncionalidade,
                            codFuncionalidade: field.codFuncionalidade
                        })
                    })
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            toggleColuna(i) {
                let ativo;
                if (this.showColunms.includes(i)) {
                    this.showColunms.splice(this.showColunms.indexOf(i), 1);
                    this.fields[i].thClass = 'd-none';
                    this.fields[i].tdClass = 'd-none';
                    ativo = false
                } else {
                    this.showColunms.push(i);
                    this.fields[i].thClass = '';
                    this.fields[i].tdClass = '';
                    ativo = true
                }

                this.atualizarConfiguracaoColunm(i, ativo)
            },

            async atualizarConfiguracaoColunm(i, ativo) {
                const json = {
                    codFuncionalidade: this.fields[i].codFuncionalidade,
                    codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                    ativo,
                };
                axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },

            incluir(evt) {
                evt.preventDefault();
                this.$router.push({path: '/regras-pagamento/incluir'});
            },

            alterar(evt) {
                evt.preventDefault();
                if (this.selecteds[0]) {
                    this.$store.commit('setPagamento', this.selecteds[0]);
                    this.$router.push({path: '/regras-pagamento/editar'});
                }
            },

            exibir(evt) {
                evt.preventDefault();
                if (this.selecteds[0]) {
                    this.$store.commit('setPagamento', this.selecteds[0]);
                    this.$router.push({path: '/regras-pagamento/exibir'});
                }
            },

            openFilterPopup(campo, tipo, values, event) {
                this.filtro.tipo = tipo;
                this.filtro.campoFiltro = campo;
                if(this.filtro.campoFiltro == 'Nome') {
                    this.filtro.filtrarEm = this.filtros.filtrarNome;
                    this.filtro.campoTexto = this.filtros.nome;
                } else if(this.filtro.campoFiltro == 'Vigência de') {
                    this.filtro.filtrarEm = this.filtros.filtrarVigenciaDe;
                    this.filtro.campoData = this.filtros.vigenciaDe;
                } else if(this.filtro.campoFiltro == 'Vigência até') {
                    this.filtro.filtrarEm = this.filtros.filtrarVigenciaAte;
                    this.filtro.campoData = this.filtros.vigenciaAte;
                } else if(this.filtro.campoFiltro == 'Receita') {
                    this.filtro.filtrarEm = this.filtros.filtrarReceita;
                    this.filtro.campoTexto = this.filtros.receita;
                } else if(this.filtro.campoFiltro == 'Índice') {
                    this.filtro.filtrarEm = this.filtros.filtrarIndice;
                    this.filtro.campoTexto = this.filtros.indice;
                } else if(this.filtro.campoFiltro == 'Valor Mínimo Parcela (R$)') {
                    this.filtro.filtrarEm = this.filtros.filtrarValorMinimo;
                    this.filtro.campoTexto = this.filtros.valorMinimo;
                } else if(this.filtro.campoFiltro == 'Percentual Pré-fixado Honorário (%)') {
                    this.filtro.filtrarEm = this.filtros.filtrarPercentual;
                    this.filtro.campoTexto = this.filtros.percentual;
                } else if(this.filtro.campoFiltro == 'Usuário Inclusão') {
                    this.filtro.filtrarEm = this.filtros.filtrarUsuario;
                    this.filtro.campoTexto = this.filtros.usuario;
                } else if(this.filtro.campoFiltro == 'Data Inclusão') {
                    this.filtro.filtrarEm = this.filtros.filtrarDataInclusao;
                    this.filtro.campoData = this.filtros.dataInclusao;
                } else if(this.filtro.campoFiltro == 'Data Última Atualização') {
                    this.filtro.filtrarEm = this.filtros.filtrarDataUltimaAtualizacao;
                    this.filtro.campoData = this.filtros.dataUltimaAtualizacao;
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.filtro.campoRadio = this.filtros.situacao;
                } else if(this.filtro.campoFiltro == 'Campo Nº Deliberação Conselho e SID') {
                    this.filtro.campoRadio = this.filtros.deliberacaoConselhoSid;
                }

                if(values != null && values != "") {
                    this.filtro.listaValores = values.split(',');
                }

                this.$refs.compFiltro.openCloseFilterPopup(event);
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoTexto = null;
                    this.filtro.campoData = null;
                    this.filtro.campoRadio = null;
                }

                if(this.filtro.campoFiltro == 'Nome') {
                    this.filtros.filtrarNome = this.filtro.filtrarEm;
                    this.filtros.nome = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Receita') {
                    this.filtros.filtrarReceita = this.filtro.filtrarEm;
                    this.filtros.receita = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Índice') {
                    this.filtros.filtrarIndice = this.filtro.filtrarEm;
                    this.filtros.indice = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Valor Mínimo Parcela (R$)') {
                    this.filtros.filtrarValorMinimo = this.filtro.filtrarEm;
                    this.filtros.valorMinimo = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Percentual Pré-fixado Honorário (%)') {
                    this.filtros.filtrarPercentual = this.filtro.filtrarEm;
                    this.filtros.percentual = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Usuário Inclusão') {
                    this.filtros.filtrarUsuario = this.filtro.filtrarEm;
                    this.filtros.usuario = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Vigência de') {
                    this.filtros.filtrarVigenciaDe = this.filtro.filtrarEm;
                    this.filtros.vigenciaDe = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Vigência até') {
                    this.filtros.filtrarVigenciaAte = this.filtro.filtrarEm;
                    this.filtros.vigenciaAte = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Data Inclusão') {
                    this.filtros.filtrarDataInclusao = this.filtro.filtrarEm;
                    this.filtros.dataInclusao = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Data Última Atualização') {
                    this.filtros.filtrarDataUltimaAtualizacao = this.filtro.filtrarEm;
                    this.filtros.dataUltimaAtualizacao = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.filtros.situacao = this.filtro.campoRadio;
                } else if(this.filtro.campoFiltro == 'Campo Nº Deliberação Conselho e SID') {
                    this.filtros.deliberacaoConselhoSid = this.filtro.campoRadio;
                }

                this.configTable.currentPage = 1;

                this.consultar();
            },
            ordenarResultados(order) {
                if(this.filtro.campoFiltro == 'Nome') {
                    this.configTable.sortField = 'pagamento.descricao';
                } else if(this.filtro.campoFiltro == 'Vigência de') {
                    this.configTable.sortField = 'pagamento.dataInicioVigencia';
                } else if(this.filtro.campoFiltro == 'Vigência até') {
                    this.configTable.sortField = 'pagamento.dataFimVigencia';
                } else if(this.filtro.campoFiltro == 'Receita') {
                    this.configTable.sortField = 'receita.descricao';
                } else if(this.filtro.campoFiltro == 'Índice') {
                    this.configTable.sortField = 'indice.descricao';
                } else if(this.filtro.campoFiltro == 'Valor Mínimo Parcela (R$)') {
                    this.configTable.sortField = 'pagamento.valorMinimoParcela';
                } else if(this.filtro.campoFiltro == 'Percentual Pré-fixado Honorário (%)') {
                    this.configTable.sortField = 'pagamento.percentualHonorario';
                } else if(this.filtro.campoFiltro == 'Usuário Inclusão') {
                    this.configTable.sortField = 'usuario.nome';
                } else if(this.filtro.campoFiltro == 'Data Inclusão') {
                    this.configTable.sortField = 'pagamento.dataHoraInclusao';
                } else if(this.filtro.campoFiltro == 'Data Última Atualização') {
                    this.configTable.sortField = 'pagamento.dataHoraUltimaAtualizacao';
                } else if(this.filtro.campoFiltro == 'Situação') {
                    this.configTable.sortField = 'pagamento.indAtivo';
                } else if(this.filtro.campoFiltro == 'Campo Nº Deliberação Conselho e SID') {
                    this.configTable.sortField = 'pagamento.delibSid';
                }

                this.configTable.sortOrder = order;

                this.consultar();
            },

            limparFiltros() {
                this.filtros = {
                    nome: null,
                    filtrarNome: null,
                    vigenciaDe: null,
                    filtrarVigenciaDe: null,
                    vigenciaAte: null,
                    filtrarVigenciaAte: null,
                    receita: null,
                    filtrarReceita: null,
                    indice: null,
                    filtrarIndice: null,
                    valorMinimo: null,
                    filtrarValorMinimo: null,
                    percentual: null,
                    filtrarPercentual: null,
                    usuario: null,
                    filtrarUsuario: null,
                    dataInclusao: null,
                    filtrarDataInclusao: null,
                    dataUltimaAtualizacao: null,
                    filtrarDataUltimaAtualizacao: null,
                    situacao: null
                };

                this.consultar();
            }
        },
        watch: {
            perPage() {
                this.configTable.currentPage = 1;
                this.consultar();
            }
        },
        computed: {
            perPage() {
                return this.configTable.perPage;
            },
        },
        mounted() {
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.$store.commit("setMessages", {});

            const msgCrud = this.$store.getters.getMsgCrud;
            if(msgCrud) {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [{message: msgCrud}]});
                this.$store.commit("setMsgCrud", null)
            }

            this.obterColunasUsuario();
            this.consultar();
        }
    }
</script>
